<template>
    <a-spin size="large" style="position: absolute; top: 50%; left: 50%; transform: translate(-50%, -50%);"/>
</template>

<script>
export default {
    name: 'Loading',
}
</script>